export interface TransferCustomerDataServiceType {
  data: number[];
}

export const TransferCustomerDataService = () : TransferCustomerDataServiceType => {
  return {
    data: []
  };
};